<template>
    <div>
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :readonly="model.paciente == enums.atestadoTipo.PACIENTE"
                        :validations="validations.nome"
                        label="Nome"
                        v-model="model.nome"
                        uppercase
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group
                                    :validations="validations.paciente"
                                    v-model="model.paciente"
                                >
                                    <rkm-form-radio :value="enums.atestadoTipo.PACIENTE">Paciente</rkm-form-radio>
                                    <rkm-form-radio :value="enums.atestadoTipo.ACOMPANHANTE">Acompanhante</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
                <rkm-col cols="10">
                    <div class="d-flex align-items-center">
                        <template>
                            <rkm-form-input
                                :disabled="true"
                                :value="getCID"
                                class="flex-grow-1 pr-2"
                                label="CID10 Principal"
                            >
                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        <rkm-form-checkbox
                                            v-if="!data.model.finalizacao.obito.cid"
                                            :validations="validations.imprimirCid"
                                            class="text-nowrap"
                                            v-model="model.imprimeCid"
                                        >
                                            Imprimir CID10
                                        </rkm-form-checkbox>
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </template>
                    </div>
                </rkm-col>
                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.dias"
                        label="Dias"
                        v-mask="getDiasMask"
                        v-model="model.dias"
                        @input="handleZeroInput()"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="align-items-end">
                <rkm-col
                    v-if="!isAtestadoAcompanhante"
                >
                    <rkm-form-input
                        :readonly="!model.documentoTipoId || isDocumentoNumeroBloqueado"
                        :validations="validations.documentoNumero"
                        label="Documento"
                        v-mask="documentoNumeroMask"
                        v-model="model.documentoNumero"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="model.documentoTipoId">
                                    <rkm-form-radio :value="enums.documentoTipo.CPF">CPF</rkm-form-radio>
                                    <rkm-form-radio :value="enums.documentoTipo.RG">RG</rkm-form-radio>
                                    <rkm-form-radio :value="enums.documentoTipo.CNH">CNH</rkm-form-radio>
                                    <rkm-form-radio :value="enums.documentoTipo.CNS">CNS</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
                <rkm-col
                    v-if="isAtestadoAcompanhante"
                >
                    <rkm-form-input
                        :validations="validations.documentoNumero"
                        label="Documento"
                        v-mask="mask.cpf"
                        v-model="model.documentoNumero"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="model.documentoTipoId">
                                    <rkm-form-radio :value="enums.documentoTipo.CPF">CPF</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-area
            title="Histórico"
            type="fieldset"
        >
            <List :data="data" />
        </rkm-area>
    </div>
</template>

<script>
// Components.
import List from './List'

// Enums.
import documentoTipo from '@/enums/cadastro/documentoTipo'
import atestadoTipo from '@/enums/pronto-atendimento/atendimento-medico/atestadoTipo'

import { formats, mask } from '@/mixins'

export default {
    components: { List },
    computed: {
        getCID() {
            return this.data.model.cid ? this.data.model.cid.nome : ''
        },
        getDocumentoNumeroValidation() {
            const validation = {
                required: true,
                min: 2,
                max: 20,
            };

            if (this.model.documentoTipoId ===  this.enums.documentoTipo.CPF) {
                validation.cpf = true
            }
            else if (this.model.documentoTipoId === this.enums.documentoTipo.CNS) {
                validation.cns = true
            }

            return validation
        },
        validations() {
            return {
                nome: { required: true },
                imprimeCid: { required: true },
                paciente: {
                    required: true,
                },
                documentoTipoId: {
                    required: true,
                },
                documentoNumero: this.getDocumentoNumeroValidation,
                dias: {
                    numeric: true,
                    max: 3,
                },
            };
        },
        getDiasMask() {
            return '###'
        },
        isDocumentoNumeroBloqueado() {
            if(this.model.documentoTipoId == this.enums.documentoTipo.CPF) {
                return !!this.data.form.paciente.cpf;
            }else if(this.model.documentoTipoId == this.enums.documentoTipo.CNS) {
                return !!this.data.form.paciente.cns;
            }

            return false;
        },
        documentoNumeroMask() {
            if (this.model.documentoTipoId ===  this.enums.documentoTipo.CPF) {
                return this.mask.cpf
            }
            else if (this.model.documentoTipoId === this.enums.documentoTipo.CNS) {
                return this.mask.cns
            }
            else {
                return '####################'
            }
        },
        isAtestadoAcompanhante() {
            if(this.model.paciente == this.enums.atestadoTipo.PACIENTE) {
                return false
            } else {
                return true
            }
        }
    },
    data: () => ({
        enums: {
            documentoTipo,
            atestadoTipo,
        },
    }),
    methods: {
        updateDocumentoNumero() {
            this.$nextTick(() => {
                if(this.model.documentoTipoId == this.enums.documentoTipo.CPF && !!this.data.model.atestado.documentoNumero) {
                    this.model.documentoNumero = this.formatCpf(this.data.form.paciente.cpf)
                }

                if(this.model.documentoTipoId == this.enums.documentoTipo.CNS && !!this.data.model.atestado.documentoNumero) {
                    this.model.documentoNumero = this.formatCns(this.data.form.paciente.cns)
                }
            })
        },
        validate() {

            return this.$refs.RkmForm.validate()
        },
        handleZeroInput(){

            let inputValue = event.target.value;

            if (inputValue.startsWith('0') && inputValue !== '0') {

                this.model.dias = inputValue.slice(1);
            } else {
                this.model.dias = inputValue;
            }
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {

                    Object.assign(this.data.model.atestado, this.model)
                    this.$emit('saved')
                }
            })
        },
    },
    mixins: [formats, mask],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'model.documentoTipoId'(value) {
            if (value ===  this.enums.documentoTipo.CPF) {
                if(this.model.paciente == this.enums.atestadoTipo.PACIENTE) {
                    this.$nextTick(() => { this.model.documentoNumero = this.formatCpf(this.data.form.paciente.cpf || '') })
                }
            }
            else if (value === this.enums.documentoTipo.RG) {
                this.$nextTick(() => { this.model.documentoNumero = this.data.form.paciente.rg })
            }
            else if (value === this.enums.documentoTipo.CNH) {
                this.$nextTick(() => { this.model.documentoNumero = this.data.form.paciente.cnh })
            }
            else if (value === this.enums.documentoTipo.CNS) {
                this.$nextTick(() => { this.model.documentoNumero = this.formatCns(this.data.form.paciente.cns || '') })
            }
        },
        'model.paciente'(value) {
            if (value == this.enums.atestadoTipo.PACIENTE) {
                this.model.nome = this.data.form.paciente.nome
                this.model.documentoTipoId = null
                this.model.documentoNumero = null
            } else {
                this.model.nome = this.data.form.recepcao.acompanhante
                this.model.documentoTipoId = '1'
                this.model.documentoNumero = null
            }
        },
    },
}
</script>